import React from 'react';
import Card from "./Card";
import {COLUMN_DEFAULT} from "../../constants";
import {Draggable, Droppable} from "react-beautiful-dnd";

const Column = (props) => {
    const {
        column      = COLUMN_DEFAULT,
        disabled    = false,
    } = props;

    return (
        <div className={"column"}>
            <div className={"header"}>
                <span>{column.label}</span>
            </div>
            <div className={"inner"}>
                <Droppable
                    droppableId={column.value}
                    isDropDisabled={disabled}
                >
                    {(provided, snapshot) => (
                        <div ref={provided.innerRef} {...provided.droppableProps} className={"droppable"}>
                            {!!column.cards && column.cards.length > 0 && column.cards.map((data, cardIndex) => {
                                return (
                                    <Draggable
                                        key={data.id}
                                        draggableId={data.id.toString()}
                                        index={cardIndex}
                                        isDragDisabled={false}
                                    >
                                        {(provided, snapshot) => (
                                            <div ref={provided.innerRef}
                                                 {...provided.draggableProps}
                                                 {...provided.dragHandleProps}>
                                                    <Card
                                                        key={data.id}
                                                        data={data}
                                                        disabled={disabled}
                                                        overlay={false}
                                                    />
                                            </div>
                                        )}
                                    </Draggable>
                                );
                            })}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </div>
        </div>
    );
}

export default Column;
